import { makeAutoObservable } from 'mobx'

import CheckableMap from '@/models/CheckableMap'

import { WorkbookPage } from './WorkbookPage'

export class WorkbookPageColl {
  pageMap: CheckableMap<number, WorkbookPage>

  constructor(list: WorkbookPage[]) {
    this.pageMap = CheckableMap.fromArr(
      list.map((page) => new WorkbookPage(page)),
      'id',
    )
    makeAutoObservable(this)
  }

  get toArr() {
    return [...this.pageMap.toArr]
  }

  get allCheckedList() {
    let arr: number[] = []
    this.toArr.forEach(({ pageProblemColl: pageDetailColl }) => {
      if (pageDetailColl?.checkedIdList) {
        arr = [...arr, ...pageDetailColl.checkedIdList]
      }
    })
    return arr
  }

  get allCheckedExampleProblemList() {
    return this.toArr
      .filter(({ pageProblemColl: pageDetailColl }) => pageDetailColl?.toCheckedValues)
      .flatMap(
        ({ pageProblemColl: pageDetailColl }) => pageDetailColl?.checkedExampleProblemIdList || [],
      )
  }

  get toCheckedValues() {
    return this.pageMap.toCheckedValues
  }

  clearAllCheckPage = () => {
    this.pageMap.clearAllCheck()
  }

  clearAllCheckProblems = () => {
    this.toArr.forEach(({ pageProblemColl: pageDetailColl }) => {
      pageDetailColl?.clearAllcheck()
    })
  }

  get isSomeChecked() {
    return this.toArr.every((col) => col.isSomeChecked)
  }

  get isAllChecked() {
    return this.toArr.every((col) => col.isAllChecked)
  }

  get size() {
    return this.pageMap.size
  }

  allCheck() {
    this.toArr.forEach((col) => col.allCheck())
  }

  clearAllCheck() {
    this.toArr.forEach((col) => col.clearAllCheck())
  }

  toggleAllCheck() {
    if (this.isAllChecked) {
      this.clearAllCheck()
    } else {
      this.allCheck()
    }
  }
}
